import { useMemo } from 'react';
import { normalizeSync } from 'normalize-diacritics';
import { Filter } from '../types';

interface SearchableProps {
  value: string;
  property: string;
  operator?: string;
  ignoreCase?: boolean;
}

export function useSearchableFilter({
  value,
  property,
  operator,
  ignoreCase = true,
}: SearchableProps) {
  const filters = useMemo(() => {
    if (!value) return [];

    let normalizedValue = normalizeSync(value).replace(/ /g, '');
    if (ignoreCase) {
      normalizedValue = normalizedValue.toLowerCase();
    }

    if (operator) {
      return [[property, operator, normalizedValue] as Filter];
    }

    return [
      [property, '>=', normalizedValue] as Filter,
      [property, '<=', normalizedValue + '\uf8ff'] as Filter,
    ];
  }, [value, ignoreCase, operator, property]);

  return { filters };
}
